import { translate } from '@jobleads-frontend/ui_library';

export default {
  methods: {
    translate,
  },
};
